import React, { useEffect, useState } from "react";
import { get, isEmpty, merge } from "lodash";
import { Form, Button, InputGroup, Image } from "react-bootstrap";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Formik, Field, FieldArray } from "formik";
import {
  getPlanSourceInformation,
  getPlanInvestments,
  deleteInvestment,
} from "../../../services";
import {
  FieldInput,
  SliderPanel,
  CsplTable as Table,
  AddPlans,
  Link,
  FieldInputDollar,
  FieldInputPercentage,
  FormControlSearch,
  WarningModal,
} from "../../../components";
import { useDeepEffect, useRequest } from "../../../abstracts";
import { required } from "../../../utils";
const columns = [
  {
    label: "Investment",
    className: "column-investment",
    columnName: "investmentName",
  },
  {
    label: "Percentage",
    className: "column-percentage",
    columnName: "percentage",
  },
  {
    label: "Action",
    className: "column-action",
    columnName: "action",
  },
];

export const DefaultElectionContainer = (props) => {
  const {
    values,
    fields,
    setFieldValue,
    isEdit,
    isSave,
    handleChange,
    planId,
    setToggle,
    toggle,
    commonError,
    errors,
    transformedEmployeeDeferralSourceList,
    //saveInvestments,
    //setSaveInvestments,
  } = props;
  const [isModalOpen, setModalOpen] = useState(false);
  const [filteredResponse, setFilteredResponse] = useState([]);

  const investmentList = get(values, "investmentList", []);
  const [total, setTotal] = useState(0);
  const planInvestment = get(values, "planInvestment", []);
  const [addedInvestments, setAddedInvestments] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const addInvestmentsToPlan = (inv) => {
    setAddedInvestments((e) => [...e, inv]);
  };
  const [modalVisible, setModalVisible] = useState(false);
  const onViewButtonClick = () => {
    setModalOpen(true);
  };
  useDeepEffect(() => {
    setFilteredResponse(investmentList);
    const total = planInvestment.reduce(
      (ini, cur) =>
        [undefined, null, ""].includes(cur.investmentPercentage)
          ? 0 + ini
          : cur.investmentPercentage + ini,
      0
    );
    setTotal(total);
    if (total != 100)
      setErrorMsg(
        "The total value of investment election should not exceed or subceed 100%"
      );
    else setErrorMsg("");
  }, [planInvestment, investmentList]);

  const onSubmit = () => {
    setFieldValue(
      "planInvestment",
      !isEmpty(planInvestment)
        ? [...planInvestment, ...addedInvestments]
        : addedInvestments
    );
    //setFilteredResponse("");
    setModalOpen(false);
    setAddedInvestments([]);
  };

  const onCancel = () => {
    // setFilteredResponse("");
    if (addedInvestments.length > 0) {
      setModalVisible(true);
    } else {
      setModalOpen(false);
    }
  };

  const modalOnCancel = () => {
    setAddedInvestments([]);
    setModalOpen(false);
    setModalVisible(false);
  };

  const onDeleteClick = (i) => {
    const list = [...get(values, "planInvestment", [])];

    list.splice(i, 1);

    setFieldValue("planInvestment", list);
  };

  const handleSearchChange = (e) => {
    const val = e.target.value;
    if (val != "" && val) {
      const searchList = investmentList.filter((f) =>
        f.investmentName.toLowerCase().includes(val.toLowerCase())
      );
      return setFilteredResponse(searchList);
    }
    setFilteredResponse(investmentList);
  };

  return (
    <div>
      <p className="mt-20 main-contribution-heading">Contribution Rate</p>
      <p className="contribution-sub-title">
        Please enter the percentage/amount to contribute to the plan.
      </p>
      <p style={{ color: "Red" }}>{commonError}</p>
      {!isEmpty(get(values, "deferralSourceContributions")) && (
        <FieldArray name="deferralSourceContributions">
          {/* <Field name="commonError" component={HiddenSelect} value='' onChange={handleChange}/> */}
          {(fieldArrayProps) =>
            transformedEmployeeDeferralSourceList.map((e, i) => {
              const fieldName = `deferralSourceContributions.${i}.contributionRate`;
              const DScontrolType =
                e.contributionType === 2
                  ? FieldInputDollar
                  : FieldInputPercentage;
              const minMaxDescription =
                e.contributionType === 2
                  ? "Minimum $" +
                    e.minimumRate +
                    " / " +
                    "Maximum $" +
                    e.maximumRate
                  : "Minimum " +
                    e.minimumRate +
                    "% / " +
                    "Maximum " +
                    e.maximumRate +
                    "%";
              //var x=getDefaultElection.sourceList.map((x,i)=>`sourceList[${i}].${x.sourceName}:${x.contributionRate}`);
              return (
                <Field
                  size="sm"
                  isRequired
                  name={fieldName}
                  label={e.sourceName}
                  hasSuggestion
                  suggestionDefaultText={minMaxDescription}
                  shouldDisplaySuggestion
                  component={DScontrolType}
                  autoComplete="off"
                  defaultValue={get(values, fieldName)}
                  onChange={handleChange(fieldName)}
                  disabled={isEdit && !isSave}
                />
              );
            })
          }
        </FieldArray>
      )}

      {!isEmpty(planInvestment) ? (
        <div className="mt-40 table-size">
          <div className="d-flex justify-content-between align-baseline">
            <p className="mt-20 List-investment-heading">
              List of Investment Election Added
            </p>
            <Button
              variant="secondary"
              onClick={() => setModalOpen(true)}
              disabled={isEdit && !isSave}
            >
              Add Investment
            </Button>
          </div>
          <div>
            <FieldArray name="planInvestment">
              {(push, remove) => {
                return (
                  <Table>
                    <Table.Thead>
                      <Table.Tr>
                        {columns.map((item, index) => {
                          return (
                            <Table.Th
                              key={index}
                              className={(item.className, "col-md-4")}
                            >
                              {item.label}
                            </Table.Th>
                          );
                        })}
                      </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                      {get(values, "planInvestment", []).map(
                        (source, index) => {
                          const fieldName = `planInvestment[${index}].investmentPercentage`;

                          return (
                            <Table.Tr key={index}>
                              <Table.Td className="column-investment col-md-4">
                                {source.investmentName}
                              </Table.Td>
                              <Table.Td className="column-percentage">
                                <Form
                                  autoComplete="off"
                                  className="h-100 percentage-field"
                                >
                                  <Field
                                    size="xs"
                                    isRequired
                                    name={fieldName}
                                    hasSuggestion
                                    shouldDisplaySuggestion
                                    component={FieldInputPercentage}
                                    type="number"
                                    value={
                                      [undefined, null, ""].includes(
                                        get(values, fieldName)
                                      )
                                        ? null
                                        : get(values, fieldName)
                                    }
                                    //defaultValue={get(values, fieldName)}
                                    onChange={handleChange}
                                    disabled={isEdit && !isSave}
                                    autoComplete="off"
                                    validate={required}
                                    // validate={(value) => {
                                    //   return value < 0.01 ? "The investment persentage cannot be less than 0.01" : undefined;
                                    // }}
                                  />
                                </Form>
                              </Table.Td>
                              <Table.Td className="column-action col-md-4">
                                <Link>
                                  <FontAwesomeIcon
                                    icon={faTrashAlt}
                                    color="red"
                                    onClick={() => {
                                      if (!(isEdit && !isSave))
                                        onDeleteClick(index);
                                    }}
                                  />
                                </Link>
                              </Table.Td>
                            </Table.Tr>
                          );
                        }
                      )}
                    </Table.Tbody>

                    <div className="line-separator-total" />
                    <Table.Tbody>
                      <Table.Tr>
                        <Table.Td className="column-investment col-md-4">
                          Total
                        </Table.Td>
                        <Table.Td className="column-percentage col-md-4">
                          <Form
                            autoComplete="off"
                            className="h-100 percentage-field"
                          >
                            <Field
                              size="xs"
                              isRequired
                              name="totalBox"
                              hasSuggestion
                              shouldDisplaySuggestion
                              component={FieldInputPercentage}
                              type="number"
                              value={total}
                              autoComplete="off"
                              validate={(value) => {
                                return total != 100 ? " " : undefined;
                              }}
                              disabled
                            />
                            {errorMsg != "" ? (
                              <p
                                style={{
                                  display: "block",
                                  color: "#ff5050",
                                  fontSize: "0.75rem",
                                  marginTop: "0rem",
                                }}
                              >
                                {errorMsg}
                              </p>
                            ) : (
                              setErrorMsg("")
                            )}
                          </Form>
                        </Table.Td>
                      </Table.Tr>
                    </Table.Tbody>
                  </Table>
                );
              }}
            </FieldArray>
          </div>
        </div>
      ) : (
        <>
          <p className="investment-heading">Investment Election</p>
          <AddPlans
            content="No Investment added"
            buttonLabel="Add Investment"
            className="h-auto"
            disabled={isEdit && !isSave}
            onPrimaryClick={onViewButtonClick}
          />
          <div className="text-danger">
            {get(errors, "deferralSourceContributions.planInvestment", "")}
          </div>
        </>
      )}

      <SliderPanel
        isOpen={isModalOpen}
        size="35"
        onClose={() => onCancel()}
        showCancel={false}
      >
        <div className="inside-content">
          <div className="d-flex justify-content-between align-baseline">
            <div>
              <p className="investment-heading">Plan Investments</p>
              <p className="investment-sub-heading">
                {investmentList && investmentList.length}{" "}
                {investmentList && investmentList.length === 1
                  ? "Investment Available"
                  : "Investments Available"}
              </p>
            </div>
            <div>
              <Button variant="secondary" onClick={() => onCancel()}>
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={() => onSubmit()}
                className="ml-4"
              >
                Save
              </Button>
            </div>
          </div>
          <div className="search-bar-investment">
            {/* <Form> */}
            <InputGroup>
              <FormControlSearch
                size="lg"
                id="plan-search-box"
                className="plan-search-box"
                type="search"
                autoComplete="off"
                placeholder="Search Investment"
                onChange={handleSearchChange}
              />
              {/* <InputGroup.Append>
                  <InputGroup.Text className="plan-search-button">
                    <Image src="/assets/icons/svg/search.svg" width="14px" />
                  </InputGroup.Text>
                </InputGroup.Append> */}
            </InputGroup>
            {/* </Form> */}
          </div>
          <div className="d-flex content-end">
            <p className="investment-side-content">
              {!isEmpty(filteredResponse) ? filteredResponse.length : 0}{" "}
              {filteredResponse.length === 1
                ? "Investment Available"
                : "Investments Available"}
            </p>
          </div>

          <div className="scroll-body">
            {filteredResponse &&
              filteredResponse?.map((e, i) => {
                return (
                  <div className="d-flex justify-content-between">
                    {values["planInvestment"] &&
                    [...values["planInvestment"], ...addedInvestments]?.find(
                      (y) => y.investmentName === e.investmentName
                    ) ? (
                      <>
                        <p className="investment-name" key={i}>
                          {e.investmentName}
                        </p>
                        <div className="added-button-inside">
                          <div className="added-button-inner-text">Added</div>
                        </div>
                      </>
                    ) : (
                      <>
                        <p key={i}>{e.investmentName}</p>
                        <div
                          className="add-button-inside"
                          onClick={() => addInvestmentsToPlan(e)}
                        >
                          <div className="add-button-inner-text">Add</div>
                        </div>
                      </>
                    )}
                  </div>
                );
              })}
          </div>
        </div>
      </SliderPanel>
      <WarningModal show={modalVisible} onHide={() => setModalVisible(false)}>
        <div className="remove-text">
          <h4>Are you sure?</h4>
          <p>Your changes may be lost. Do you want to continue ?</p>
          <Button
            type="button"
            className="remove-btn mr-4"
            onClick={() => modalOnCancel()}
          >
            Yes
          </Button>
          <Button className="cancel-btn" onClick={() => setModalVisible(false)}>
            No
          </Button>
        </div>
      </WarningModal>
    </div>
  );
};
